var helperFn = function (asyncFn, args, predicate, resolve, reject, pollInterval, postInitFunction) {
    var timeoutId;
    var cancelFunctions = [];
    var cancelled = false;
    var cancel = function () {
        cancelled = true;
        cancelFunctions.forEach(function (cf) { return cf(); });
        clearTimeout(timeoutId);
    };
    if (postInitFunction) {
        postInitFunction(cancel);
    }
    asyncFn.apply(void 0, args).then(function (res) {
        if (predicate(res)) {
            resolve(res);
        }
        else {
            if (!cancelled) {
                timeoutId = setTimeout(function () {
                    if (!cancelled) {
                        helperFn(asyncFn, args, predicate, resolve, reject, pollInterval, function (cf) { return cancelFunctions.push(cf); });
                    }
                }, pollInterval);
            }
        }
    })
        .catch(function (err) { return reject(err); });
};
export var promisePoll = function (asyncFn, args, predicate, pollInterval, postInitFunction) {
    if (pollInterval === void 0) { pollInterval = 0; }
    return new Promise(function (resolve, reject) {
        var cancelFunctions = [];
        if (postInitFunction) {
            var cancel = function () { return cancelFunctions.forEach(function (cf) { return cf(); }); };
            postInitFunction(cancel);
        }
        helperFn(asyncFn, args, predicate, resolve, reject, pollInterval, function (cf) {
            return cancelFunctions.push(cf);
        });
    });
};
